import styled from 'styled-components';

export const InputContainer = styled.div`
  display: grid;
  gap: 26px;
  grid-template-columns: 75%;
`;
